export default __webpack_public_path__ + "static/media/carbohydrates.7fa8abe9.cms";